<template>
  <div></div>
  <div style="display: flex; justify-content: center; align-items: center; height: 60vh; flex-direction: column;">
    <el-icon class="is-loading" style="font-size: 48px; margin-bottom: 16px;">
      <Loading />
    </el-icon>
    <div>正在链接GitHub服务器...</div>
    <div>如果中断，请多试几次</div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted,reactive } from "vue";
import axiosInstance from "@/utils/axiosInstance";
import { useRouter } from "vue-router";
import { useOAuthStore } from "@/stores/oauth";
import { useUserInfoStore } from "@/stores/userInfo";
import { ElMessage } from "element-plus";

const router = useRouter();
const authStore = useOAuthStore();
const userInfoStore = useUserInfoStore();

const pagestate = reactive({
  backcode: "",
  token: "",
});

onMounted(async () => {
  // 获取 code 参数
  const code = router.currentRoute.value.query.code as string;
  GitHubCallBack(code);
});

//github authorization callback  api/OAuthGithub/GithubCallback
const GitHubCallBack = (code: string) => {
  axiosInstance
    .get("api/GithubAuth/GithubCallback", {
      params: {
        code: code,
      },
      timeout: 180000
    })
    .then((res) => {
      var result = res.data;
      if (result.success) {
        authStore.setToken(result.data.token);
        GetUserInfo(result.data.token);
      }
      else{
        ElMessage.error(result.msg);
        const redirectUrl = localStorage.getItem('OAUTH_LOGIN_URL') || '/';
        localStorage.removeItem('OAUTH_LOGIN_URL');
        router.push(redirectUrl);
      }
    });
};

// get userinfo by token
const GetUserInfo = (token: string) => {
  axiosInstance
    .get("api/UserInfo/GetUserInfoByToken", {
      params: {
        token: token
      },
    })
    .then((res) => {
      var result = res.data;
      pagestate.token = result.data;
      if (result.success) {
        userInfoStore.setUser(result.data);
        const redirectUrl = localStorage.getItem('OAUTH_LOGIN_URL') || '/';
        localStorage.removeItem('OAUTH_LOGIN_URL');
        router.push(redirectUrl);
      }
    });
};
</script>
